import * as api from './api';
import * as MutationTypes from './mutationTypes';
import { FrontMenuProductDynamicDataList } from './models';

export const getMenuProductDynamicDataListRequest = async ({ commit, getters: { frontMenuProductDynamicDataList } }, { saleRateGuid, startDate, endDate }) => {
  if (!frontMenuProductDynamicDataList
    || frontMenuProductDynamicDataList.saleRateGuid !== saleRateGuid
    || frontMenuProductDynamicDataList.startDate !== startDate
    || frontMenuProductDynamicDataList.endDate !== endDate) {
    const response = await api.getMenuProductDynamicDataListRequest(saleRateGuid, startDate, endDate);
    const mpddList = FrontMenuProductDynamicDataList.toInstance(response.data);
    commit(MutationTypes.GET_MENU_PRODUCT_DYNAMIC_DATA_LIST_SUCCESS, mpddList);
  }
};

export const updateMenuProductDynamicDataListRequest = async ({ commit }, { mpddsToUpdate }) => {
  await api.updateMenuProductDynamicDataListRequest(mpddsToUpdate.serialize());
  commit(MutationTypes.UPDATE_MENU_PRODUCT_DYNAMIC_DATA_LIST_SUCCESS);
};

export const applyMenuProductDynamicDataListChanges = async ({ commit }, { mpddOrderChanges, mpddSpecialChanges, mpddIsVisibleChanges }) => {
  commit(MutationTypes.APPLY_MENU_PRODUCT_DYNAMIC_DATA_LIST_CHANGES, { mpddOrderChanges, mpddSpecialChanges, mpddIsVisibleChanges });
};
